/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { useComponentProps } from '@sitecore-content-sdk/nextjs';
import { getTestProps } from 'lib/testing/utils';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import ArticleSearchWidget from 'widgets/ArticleListing';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ArticleListingClient = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    const { sitecoreContext } = useSitecoreContext();
    // App Router + Content SDK 2.0: AppPlaceholder only forwards
    // { fields, params, rendering }, so the `getComponentServerProps` result
    // lives in ComponentPropsContext keyed by rendering UID. Read it back here.
    const ctxProps = useComponentProps(props?.rendering?.uid);
    const staticProps = props?.staticProps ?? ctxProps?.staticProps ?? {
        currentTemplate: '',
        currentCategory: ''
    };
    const searchSources = sitecoreContext?.siteSettings?.globalSearchSourceId?.value;
    const sources = searchSources ? searchSources.split('|').map((s)=>s.trim()).filter((s)=>s) : [];
    const rfkid = sitecoreContext?.siteSettings?.globalSearchWidgetId?.value;
    return /*#__PURE__*/ _jsx("section", {
        id: id ? id : undefined,
        "data-component": "authorable/shared/page-specific/articlelisting",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-article-listing-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(ArticleSearchWidget, {
            rfkId: rfkid || '',
            searchSources: sources,
            ...props,
            staticProps: staticProps,
            ...getTestProps(`article-search-widget`)
        })
    });
};
export default ArticleListingClient;
